import { render, staticRenderFns } from "./ProjectPageTabs.vue?vue&type=template&id=5c202593&scoped=true"
import script from "./ProjectPageTabs.vue?vue&type=script&lang=js"
export * from "./ProjectPageTabs.vue?vue&type=script&lang=js"
import style0 from "./ProjectPageTabs.vue?vue&type=style&index=0&id=5c202593&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c202593",
  null
  
)

export default component.exports